import { Grid, Paper } from '@mui/material';
import { Box } from '@mui/system';
// import axios from "axios";
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

import { fetchFiles } from '../../Api/suiviMission/files';
import FileList from '../../Components/suiviMission/FileList';
import FileUpload from '../../Components/suiviMission/FileUpload';
import HeaderBar from '../../Components/suiviMission/HeaderBar';
// import UploadBox from "../components/UploadBox";
import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';

const Ressources = () => {
    const [list, setlist] = useState([]);

    const { mission } = useGlobalContext();

    useEffect(() => {
        if (!mission._id) return;
        fetchFiles(setlist, mission._id);
    }, [mission]);
    useEffect(() => {
        console.log(list);
    }, [list]);

    return (
        <Box
            sx={{ width: '100%',
                position: 'relative',
                top: '110px', //* comment this top if you want this navBar to replace the other (older)
                zIndex: '10'}}
        >
            <HeaderBar title={'Ressources '} />
            <Paper
                elevation={3}
                className="my-3 "
                square="true"
                sx={{
                    borderRadius: '1.5rem',
                    height: '100%',
                    margin: '10px',
                    padding: '20px',
                }}
            >
                <Grid container>

                    <Grid
                        item
                        xs={12}
                        sx={{
                            marginLeft: '100px',
                            marginRight: '100px',
                            marginTop: '20px',
                        }}
                    >
                        <FileUpload setlist={setlist} />

                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        <FileList
                            list={list}
                            setlist={setlist}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    );
};

export default Ressources;